<template>
  <content-box class="signup-auth-layer" :width="'430px'">
    <div v-if="authParam.value === 'signup_ok'" class="auth__success">
      <i class="icon icon--check-green-size50"></i>
      <p class="title">{{ $t('account.signUp.auth.success.title') }}</p>
      <p class="desc" v-html="$t('account.signUp.auth.success.desc')"></p>
      <ui-button :primary2="true" @click="onCloseLayer">{{ $t('common.confirm') }}</ui-button>
    </div>
    <div v-else-if="authParam.value === 'signup_key_expired'" class="auth__error">
      <i class="icon icon--alert-size50"></i>
      <p class="title">{{ $t('account.signUp.auth.expired.title') }}</p>
      <p class="desc" v-html="$t('account.signUp.auth.expired.desc')"></p>
      <ui-button :primary2="true" @click="onCloseLayer">{{ $t('common.close') }}</ui-button>
    </div>
  </content-box>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'

export default {
  components: {
    ContentBox,
    UiButton
  },
  props: [
    'authParam'
  ],
  methods: {
    onCloseLayer () {
      this.$emit('closeLayer')
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.signup-auth-layer {
  @include positionXYcenter;
  padding: 50px 30px 25px;
  text-align: center;

  .title {
    font-size: 20px;
    font-weight: bold;
    color: #444444;
    margin-top: 15px;
  }
  .desc {
    font-size: 14px;
    color: #2f2f2f;
    line-height: 1.43;
    margin-top: 12px;
  }
  .ui-btn {
    margin-top: 40px;
  }
}
</style>
